export const generateMicroreelText = {
  title: 'Tapybl AI',
  subtitle: 'Powered by AI, driven by you',
  generateTitle: 'Create new microreels',
  promptTitle: 'Hey, what do you want to create today?',
  promptSubtitle:
    "Describe what you'd like your microreels to be about. This may take a few minutes - we'll notify you when they're ready",
  promptPlaceholder: 'Enter an idea to generate a set of microreels',
  titleField: 'Title',
  titleDescription: 'Choose a title for your generated microreels',
  numberOfMicroreels: 'Number of microreels',
  numberOfMicroreelsSubtitle: 'How many microreels to generate (1-6)',
  includeGrading: 'Verify learner comprehension',
  assesmentSubtitle:
    'Verify learner comprehension levels using auto-generated assessments',
  mandatoryMicroreelsTitle: 'Which microreels are mandatory?',
  mandatoryMicroreelsSubtitle:
    'Select one or more microreels that learners must complete. The rest will be optional.',
  enableAckNode: 'Enable acknowledgement',
  enableAckNodeSubtitle:
    'Insert an acknowledgement step so learners can confirm understanding before continuing',
  selectLanguage: 'Language & accent',
  selectLanguageSubtitle:
    'Select the language and accent in which you wish to generate content',
  backgroundMusicLabel: 'Add background music',
  backgroundMusicMoodLabel: 'Choose music by mood',
  selectMusicPlaceholder: 'Select music',
  orSelectFromLibrary: 'Or select from your library',
  cancel: 'Cancel',
  generate: 'Generate microreels',
  viewMicroreels: 'View microreels',
  generationStarted: 'Microreels generation started',
  generationCanceled: 'Generation canceled',
  generationUnavailable:
    'Another AI generation is currently in progress. Refresh this page once it completes to start a new one.',
  generationUnavailableTooltip:
    'Another generation is in progress — refresh this page once it completes.',
  newMicroreel: 'New microreel',
  createReel: 'Create reel',
  creatingReel: 'Creating…',
  source: 'Source',
  sourceHint: 'Amount of data + length = amount of reels',
  addSource: 'Add a document from your library',
  sourceEmptyTitle: 'Have content to build from?',
  sourceEmptyDrop: 'Drop a document or video here',
  uploadFile: 'Upload file',
  uploading: 'Uploading…',
  chooseFromLibrary: 'Choose from library',
  sourceFormats: 'PDF, DOCX, PPTX, MP4 · up to 200 MB',
  sourceNoFileBold: 'No file?',
  sourceNoFileText:
    "That's fine. The reel will be written entirely from your prompt.",
  writePrompt: 'Write a prompt',
  musicFromLibrary: 'Choose from library…',
  aroundCredits: (count: number) => `Around ${count.toLocaleString('en-US')}`,
  summarizeTitle: 'Summarize document',
  summarizeHint:
    'AI condenses the document into one short slide per reel before writing them',
  replace: 'Replace',
  remove: 'Remove',
  teachTitle: 'What should this reel teach?',
  lengthTitle: 'Length',
  lengthShort: '30-60 sec',
  lengthMedium: '1-2 min',
  lengthLong: '2-5 min',
  backgroundMusic: 'Background music',
  noMusic: 'None',
  actionsTitle: 'Actions in the end',
  actionNone: 'None',
  actionKnowledgeCheck: 'Knowledge check',
  actionAttestation: 'Policy attestation',
  customizeTitle: 'Customize language',
  customizeTitleFull: 'Customize language, voice, narration',
  visualsTitle: 'Visuals',
  visualsSource: 'Content from the source',
  visualsSourceHint: 'Scenes show only your content',
  visualsPartial: 'Partially generate media',
  visualsPartialHint: 'Your text with an AI image in every scene',
  visualsGenerated: 'Show generated media only',
  visualsGeneratedHint: 'Scenes use only generated media',
  mediaSourceTitle: 'Generated media source',
  mediaStoryblocks: 'Storyblocks',
  mediaStoryblocksHint: 'Licensed stock footage',
  mediaAiImages: 'AI generated images',
  mediaAiImagesHint: 'New visuals for every scene',
  mediaBoth: 'Both',
  mediaBothHint: 'Stock footage and AI images',
  languageTitle: 'Language',
  voiceTitle: 'Voice',
  voiceFemaleName: 'Emma',
  voiceFemaleHint: 'Warm, clear',
  voiceMaleName: 'James',
  voiceMaleHint: 'Confident',
  voiceOriginal: 'Original audio',
  voiceOriginalHint: 'The audio from your video is kept',
  languageOnScreenHint: 'On-screen text',
  selectFile: 'Select file',
  voiceFemaleDetailsHint: 'Warm, clear AI narration',
  voiceMaleDetailsHint: 'Confident AI narration',
  visualsFromVideo: 'From your video',
  visualsFromVideoHint: 'Scenes taken from the uploaded video',
  narrationTitle: 'Narration depth',
  narrationBrief: 'Brief',
  narrationBriefHint: 'Headlines and key points only',
  narrationStandard: 'Standard',
  narrationStandardHint: 'Balanced explanation',
  narrationDetailed: 'Detailed',
  narrationDetailedHint: 'Full walkthrough of content',
  page: 'Page',
  pageOf: 'of',
  excludePages: 'Exclude pages',
  excludePagesPlaceholder: 'e.g. 11,12-15',
  estimatedMinutes: 'min',
  estimatedCredits: 'credits',
  invalidSourceType:
    'Only PDF, Word, PowerPoint or video files can be used as a source',
};
